export const getDate = (monthOffset = 0) => {
    const d = new Date();
    d.setMonth(d.getMonth() + monthOffset);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
